import { Box, Button, IconButton, Typography } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { palette } from "../../../theme/palette";

const CreateNodeButton = ({
  icon,
  title,
  description,
  onClick,
  isAIBtn = false,
}) => {
  return (
    <Button
      variant="text"
      onClick={onClick}
      sx={{
        width: "100%",
        maxWidth: { xs: "100%", sm: "500px", md: "465px" },
        minHeight: { xs: "auto", sm: "94px" },
        textAlign: "left",
        justifyContent: "flex-start",
        alignItems: "center",
        p: {
          xs: "12px 10px",
          sm: "16px 12px",
          md: "20px 16px",
        },
        borderRadius: { xs: "10px", sm: "12px" },
        backgroundColor: "#fff",
        border: "1px solid #e5e7eb",
        textTransform: "none",
        transition: "all 0.3s ease",
        "&:hover": {
          boxShadow: `0 8px 12px ${palette.primary.main}66`,
          backgroundColor: "primary.main",
          borderColor: "primary.main",
          color: "#fff",
          transform: { sm: "translateY(-2px)" },
          // boxShadow: { sm: "0 4px 12px rgba(0, 0, 0, 0.1)" },
          "& .MuiTypography-root": {
            color: "#fff",
          },
          "& .MuiSvgIcon-root": {
            color: "#fff",
          },
          "& .iconContainer": {
            backgroundColor: "#2664e0",
          },
          "& .betaBadge": {
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            color: "#fff",
          },
          "& .buttonIcon": {
            filter: "brightness(0) invert(1)",
          },
        },
        "& .arrowIcon": {
          // display: { xs: "none", md: "none" },
          opacity: 0,
          transform: "translateX(0px)",
          transition: "all 0.5s ease-in-out",
        },
        "&:hover .arrowIcon": {
          // display: { xs: "none", md: "flex" },
          opacity: 1,
          transform: "translateX(15px)",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          gap: { xs: 1.5, sm: 2 },
        }}
      >
        {/* Left Section - Icon + Content */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: { xs: 1.5, sm: 2 },
            flex: 1,
            minWidth: 0,
          }}
        >
          {/* Icon Container */}
          <Box
            className="iconContainer"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#F3F4F6",
              width: { xs: "40px", sm: "50px" },
              height: { xs: "40px", sm: "50px" },
              borderRadius: { xs: "6px", sm: "8px" },
              flexShrink: 0,
              transition: "background-color 0.3s ease",
            }}
          >
            <Box
              component="img"
              src={icon}
              alt={title}
              className="buttonIcon"
              sx={{
                width: { xs: 18, sm: 23 },
                height: { xs: 18, sm: 23 },
                objectFit: "contain",
                transition: "filter 0.3s ease",
              }}
            />
          </Box>

          {/* Text Content */}
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
            }}
          >
            {/* Title Row */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: { xs: 0.5, sm: 0.75 },
                flexWrap: "wrap",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: "0.95rem", sm: "1rem", md: "1.05rem" },
                  lineHeight: 1.3,
                  transition: "color 0.3s ease",
                }}
              >
                {title}
              </Typography>
              {isAIBtn && (
                <Typography
                  variant="body2"
                  className="iconContainer betaBadge"
                  sx={{
                    backgroundColor: "#F3F4F6",
                    color: "#666",
                    px: { xs: 1, sm: 1.25 },
                    py: 0.25,
                    borderRadius: "20px",
                    fontSize: { xs: "0.7rem", sm: "0.75rem" },
                    fontWeight: 600,
                    transition: "all 0.3s ease",
                  }}
                >
                  Beta
                </Typography>
              )}
            </Box>

            {/* Description */}
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: "0.8rem", sm: "0.85rem", md: "0.9rem" },
                lineHeight: 1.5,
                color: "#666",
                transition: "color 0.3s ease",
                display: { xs: "-webkit-box", sm: "block" },
                WebkitLineClamp: { xs: 2, sm: "none" },
                WebkitBoxOrient: { xs: "vertical", sm: "initial" },
                overflow: { xs: "hidden", sm: "visible" },
                textOverflow: { xs: "ellipsis", sm: "clip" },
              }}
            >
              {description}
            </Typography>
          </Box>
        </Box>

        {/* Right Section - Arrow Icon (Desktop Only) */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            flexShrink: 0,
          }}
        >
          <IconButton
            className="arrowIcon"
            aria-label="arrow"
            sx={{
              p: 0.5,
              transition: "all 0.3s ease",
            }}
          >
            <ArrowForwardIosIcon
              sx={{
                fontSize: { md: "1rem", lg: "1.1rem" },
              }}
            />
          </IconButton>
        </Box>
      </Box>
    </Button>
  );
};

export default CreateNodeButton;
